import {CreateReducer} from '../utils/create_reducer';
import {
    CLEAR_DATA,
    GET_ESTIMATE_DETAIL,
    GET_REMITTANCE_DETAIL,
    GET_REMITTANCE_ESTIMATES_LIST,
    GET_REMITTANCE_LIST
} from "../actions/account_remittance_action";

const initState = {
    remittances: [],
    estimates: [],
    isFetching: true,
    remittanceDetail: undefined,
    estimateDetail: undefined
};

const accountRemittanceReducer = CreateReducer(initState, {
    [GET_REMITTANCE_LIST](state, action) {
        return {...state, remittances: action.payload, isFetching: false}
    },
    [GET_REMITTANCE_ESTIMATES_LIST](state, action) {
        return {...state, estimates: action.payload, isFetching: false}
    },
    [GET_REMITTANCE_DETAIL](state, action) {
        return {...state, remittanceDetail: action.payload, isFetching: false}
    },
    [GET_ESTIMATE_DETAIL](state, action) {
        return {...state, estimateDetail: action.payload, isFetching: false}
    },
    [CLEAR_DATA](state, action) {
        return {...initState}
    }
});

export default accountRemittanceReducer;


// WEBPACK FOOTER //
// ./src/reducers/account_remittance_reducer.js